import { useCmsClientContext } from '../cmsPageContext';
import { BrandId } from '../override';

/**
 * Country code in `ISO 3166-1 alpha-2` format
 */
export type CountryCode = string & { __countryCodeBrand: symbol };

/**
 * Determine which country we are currently running on
 * @returns Country code in `ISO 3166-1 alpha-2` format
 */
export const useCurrentCountry = (): CountryCode => {
  const { brand } = useCmsClientContext();

  const brandToCountryCode: Record<BrandId, string> = {
    singsaver: 'SG',
    moneyhero: 'HK',
    money101: 'TW',
    moneymax: 'PH',
  };

  return brandToCountryCode[brand] as CountryCode;
};
